import React from 'react';
import styled from 'styled-components';

interface DevOnlyProps {
  icon?: boolean;
  style?: React.CSSProperties;
}

export const isDev = process.env.NODE_ENV === 'development';
export const DevOnly: React.FC<React.PropsWithChildren<DevOnlyProps>> = ({ icon, style, children }) => {
  if (!isDev) {
    return null;
  }
  return (
    <StyledDevOnly icon={icon} style={style}>
      {children}
    </StyledDevOnly>
  );
};
DevOnly.displayName = 'Dev Only';

const StyledDevOnly = styled.span<{ icon?: boolean }>`
  && {
    position: relative;

    &:hover::before {
      content: 'Dev Only';
      display: block;
      white-space: nowrap;
      position: absolute;
      font-size: 10px;
      color: white;
      background: red;
      padding: 4px;
    }

    ${({ icon }) =>
      icon
        ? `
      .MuiIconButton-label {
        border: 2px dashed #de0000;
      }

      &:hover::before {
        top: -32px;
        left: 3px;
      }
    `
        : `
      border: 2px dashed #de0000;
      display: inline-flex;

      &:hover::before {
        top: -10px;
      }
    `}
  }
`;
